import * as Yup from 'yup'

export const getValidationSchema = (t) => {
  return Yup.object().shape({
    firstName: Yup.string().required(
      t('points:connectionDrawer.fields.firstName.required'),
    ),
    lastName: Yup.string().required(
      t('points:connectionDrawer.fields.lastName.required'),
    ),
    email: Yup.string()
      .email(t('points:connectionDrawer.fields.email.invalid'))
      .required(t('points:connectionDrawer.fields.email.required')),
  })
}
